<template>
  <router-link :style="{textDecoration: 'none', cursor: value.to ? 'pointer' : 'default'}"
               :to="getToObj"
               :target="isIosOrAndroidApp ? '_self' : '_blank'"
               v-if="value && value.to"
               @click.native="instrumentClicked">
    <InstrumentNameCell v-bind="$props"/>
  </router-link>
  <InstrumentNameCell v-else v-bind="$props"/>
</template>

<script>
import InstrumentNameCell from "./InstrumentNameCell"
import AmplitudePush from "@/mixins/AmplitudePush"
import finBrowser from "@/js/finBrowser"

export default {
  name: "InstrumentNameCellToDetailPage",
  mixins: [AmplitudePush],
  props: {
    value: {},
    item: {},
    header: {},
    isMobile: {}
  },
  data() {
    return {
      isIosOrAndroidApp: finBrowser.IS_IOS_OR_ANDROID_APP
    }
  },
  computed: {
    getToObj() {
      if (this.value.to) {
        return {name: this.value.to.name, params: {id: this.value.to.params.id}, query: {tab: 'new'}}
      } else {
        return {path: this.$route.path}
      }
    },
  },
  methods: {
    instrumentClicked() {
      this.pushToAmplitude({
        'event': 'fincraft_goto_instrument',
        'step': 'goto_instrument',
        'placement': 'fincraft_instruments_table',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
    }
  },
  components: {
    InstrumentNameCell
  }
}
</script>

<style lang="scss" scoped>
.title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px !important;
  line-height: 1.38;
  font-weight: bold;
  font-family: $body-font-family !important;
}

.subtitle {
  font-size: 12px;
  color: #99a0a4;
  line-height: 1.4;
}
</style>
